import { render, staticRenderFns } from "./AddTime.vue?vue&type=template&id=2ba22ec6"
import script from "./AddTime.vue?vue&type=script&lang=js"
export * from "./AddTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports